import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './components/Home';
import Archive from './components/Archive';
import Blog from './components/Blog';
import BlogAuth from './components/BlogAuth';

/***********************
  Main App Component
 ***********************/

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/archive/2024/uoh/soupbg" element={<Archive />} />
        <Route path="/blog" element={<BlogAuth />} />
        <Route path="/blog/caffeine-chaos-cardano" element={<Blog />} />
      </Routes>
    </Router>
  );
};

export default App;